import { NoMarginWrapper } from "../hoc";
import { slides } from "../constants";
import "./Slider.css";
import React, { useEffect, useState } from "react";

let photos = slides;

const Whoami = () => {
  const [sliderClass, setSliderClass] = useState("");
  const [animateKey, setAnimateKey] = useState(0);
  const [thumbnailSize, setThumbnailSize] = useState(4);

  const nextSlide = () => {
    setSliderClass("next");
    let firstElement = photos.shift();
    photos.push(firstElement);

    // Force key change to re-trigger animation on first slide
    setAnimateKey((prev) => prev + 1);
  };

  const prevSlide = () => {
    setSliderClass("prev");
    let lastElement = photos.pop();
    photos.unshift(lastElement);

    // Force key change to re-trigger animation on first slide
    setAnimateKey((prev) => prev + 1);
  };

  useEffect(() => {
    const timer = setTimeout(() => setSliderClass(""), 500);
    return () => clearTimeout(timer);
  }, [sliderClass]);

  useEffect(() => {
    const mediaQueries = [
      { query: window.matchMedia("(max-width: 700px)"), size: 1 },
      { query: window.matchMedia("(max-width: 1020px)"), size: 2 },
      { query: window.matchMedia("(max-width: 1350px)"), size: 3 },
      { query: window.matchMedia("(min-width: 1351px)"), size: 4 },
    ];

    const handleMediaChange = () => {
      const matchedQuery = mediaQueries.find((mq) => mq.query.matches);

      if (matchedQuery) {
        setThumbnailSize(matchedQuery.size);
      }
    };

    handleMediaChange();
    mediaQueries.forEach((mq) => mq.query.addEventListener("change", handleMediaChange));

    return () => {
      mediaQueries.forEach((mq) => mq.query.removeEventListener("change", handleMediaChange));
    };
  }, []);

  return (
    <div className={`slider ${sliderClass}`}>
      <div className="list">
        {photos.map((slide, index) => (
          <div key={index} className={`item`}>
            <img src={slide.img} alt={slide.type} />
            <div
              key={index === 0 ? animateKey : index}
              className={`content ${index === 0 ? "animate" : ""}`}
            >
              <div className="title">{slide.title}</div>
              <div className="type">{slide.type}</div>
              <div className="description">{slide.description}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="thumbnail">
        {photos.slice(1, thumbnailSize + 1).map((slide, index) => (
          <div key={index} className={`item`}>
            <img src={slide.img} alt={slide.type} />
          </div>
        ))}
      </div>

      <div className="nextPrevArrows">
        <button className="prev" onClick={prevSlide}>
          {"<"}
        </button>
        <button className="next" onClick={nextSlide}>
          {">"}
        </button>
      </div>
    </div>
  );
};

export default Whoami;
